import React from 'react'
import { Link } from 'react-router-dom'
import { useRef } from 'react';

const User = ({locUser}) => {
  const myaccountBox = useRef(null);
  function Toggle(){
      if(myaccountBox.current.className.includes('active')){
          myaccountBox.current.className = 'admin_header_user_button';
      }
      else{
          myaccountBox.current.className = 'admin_header_user_button active';
      }
  }
  const SignOut = () =>{
    localStorage.removeItem('user-info');
    document.location.reload();
  }
  return (
    <div className='admin_header_user_wrapper'>
      <div className='admin_header_user_button' ref={myaccountBox} onClick={Toggle}>
        <button type='button'>
            <h6>{locUser.username}</h6>
            <p>{locUser.email}</p>
        </button>
        <div className='admin_header_user_list'>
            <ul>
             <Link to='/admin'><li>Password</li></Link> 
             <li onClick={SignOut}>SignOut</li> 
            </ul>
        </div>
      </div>
    </div>
  )
}

export default User
